import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import Filtro_ObjetivoMensual from "../ObjetivoMensual/Filtro_ObjetivoMensual";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory } from "react-router-dom";
import WalletIcon from "@mui/icons-material/Wallet";
import { CapitalizarCadena } from "../../../Helpers/CaptitalizarCadena";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChartRecuperacionCarteraMensual from "./ChartRecuperaciondeCarteraMensual";
import { useBox } from "../ReporteCobranza/Helper/useBox";
import { GetKey } from "../ReporteCobranza/Actions/GetContainer";
import Swal from "sweetalert2";
const RecuperacionCarteraMensualScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const [state, setState] = useState({
    total: [],
    operacion: [],
    revolvente: [],
  });

  const onHome = () => {
    history.push("/Creditoycobranza/Main");
  };
  const onExecute = (ejercicio) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `RecuperacionCarteraMensual/ObtenerObjetivoRecuperado?ejercicio=${Number(
            ejercicio
          )}&sucursales=${sucursales}&adr=${adr}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setState({
            total: result.total,
            operacion: result.operacion,
            revolvente: result.revolvente,
          });
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };
  useEffect(() => {
    const añoActual = new Date().getFullYear();
    onExecute(añoActual);
  }, []);
  const GetClassIndicador = (value) => {
    if (value === "R") return "alert-red";
    else if (value === "A") return "alert-yellow";
    else if (value === "V") return "alert-success";
    else return "alert-red";
  };
  const GetClassIndicadordouble = (value) => {
    if (value === "RR") return "alert-red";
    else return "d-none";
  };

  const onGeneraExcel = (ejercicio) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    // return;
    setLoader({ ...loader, mostrar: true });
    request
      .get(`RecuperacionCarteraMensual/ImprimirExcel?ejercicio=${Number(
            ejercicio
          )}&sucursales=${sucursales}&adr=${adr}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onGeneraPDF = (ejercicio) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    setLoader({ ...loader, mostrar: true });
    request
    .get(`RecuperacionCarteraMensual/ImprimirPDF?ejercicio=${Number(
      ejercicio
    )}&sucursales=${sucursales}&adr=${adr}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };


  // console.log(boxstate)

  return (
    <PlantillaScreen
      titulo={"RECUPERACION DE CARTERA"}
      className_main={1}
      className={"reporte-recuperacion-cartera-objetivo"}
    >
      <div className="resumen-saldos-cartera-objetivo-header-mensual">
        <Filtro_ObjetivoMensual
          onExecute={onExecute}
          boxState={boxstate}
          onBoxChange={setBoxState}
        />
      </div>
      <div className="buttons">
          <button className="excel" 
            onClick={() => onGeneraExcel(boxstate.ejercicio)}
          >
            <i className=" icon-file-excel" /> Excel
          </button>
          <button className="PDF" 
          onClick={() => onGeneraPDF(boxstate.ejercicio)} 
          style={{backgroundColor:'#940404'}}>
            PDF
          </button>
        </div>
      <div className="resumen-saldos-cartera-objetivo scroll-4">
        <LoaderScreen loader={loader} />
        {state.total !== undefined &&
        state.total !== undefined &&
        state.total.length > 0 ? (
          <>
            <div className="resumen-saldos-cartera-objetivo-titulo">
              <WalletIcon />
              Total Cartera
            </div>
            <div className="resumen-saldos-cartera-objetivo-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th></th>
                    <th colSpan={5}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {state.total.map((item) => (
                    <tr>
                      <td>
                        <div className="td-icono-principal">
                          <CalendarMonthIcon />
                          {CapitalizarCadena(item.mes)}
                        </div>
                      </td>

                      <td>{FormatMoney(item.cartera_activa, 0)}</td>
                      <td>{FormatMoney(item.cartera_porvencer, 0)}</td>
                      <td>{FormatMoney(item.cartera_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_cartera, 0)}</td>
                      <td>{FormatMoney(item.objetivo, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_mes, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_activa, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_porvencer, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_recuperado, 0)}</td>
                      <td>{FormatMoney(item.recuperado, 0)}</td>
                      <td className="ta-right">{item.porc}</td>
                      <td className="td-porcentaje">
                        <div className="porcentaje">
                          <div
                            className={GetClassIndicador(item.indicador)}
                          ></div>
                          <div
                            className={GetClassIndicadordouble(item.indicador)}
                          ></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-objetivo-titulo">
              <WalletIcon /> Cartera de Operación
            </div>
            <div className="resumen-saldos-cartera-objetivo-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th></th>
                    <th colSpan={5}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {state.operacion.map((item) => (
                    <tr>
                      <td>
                        <div className="td-icono-principal">
                          <CalendarMonthIcon />
                          {CapitalizarCadena(item.mes)}
                        </div>
                      </td>
                      <td>{FormatMoney(item.cartera_activa, 0)}</td>
                      <td>{FormatMoney(item.cartera_porvencer, 0)}</td>
                      <td>{FormatMoney(item.cartera_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_cartera, 0)}</td>
                      <td>{FormatMoney(item.objetivo, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_mes, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_activa, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_porvencer, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_recuperado, 0)}</td>
                      <td>{FormatMoney(item.recuperado, 0)}</td>
                      <td className="ta-right">{item.porc}</td>
                      <td className="td-porcentaje">
                        <div className="porcentaje">
                          <div
                            className={GetClassIndicador(item.indicador)}
                          ></div>
                          <div
                            className={GetClassIndicadordouble(item.indicador)}
                          ></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-objetivo-titulo">
              <WalletIcon />
              Cartera Revolvente
            </div>
            <div className="resumen-saldos-cartera-objetivo-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th></th>
                    <th colSpan={5}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {state.revolvente.map((item) => (
                    <tr>
                      <td>
                        <div className="td-icono-principal">
                          <CalendarMonthIcon />
                          {CapitalizarCadena(item.mes)}
                        </div>
                      </td>
                      <td>{FormatMoney(item.cartera_activa, 0)}</td>
                      <td>{FormatMoney(item.cartera_porvencer, 0)}</td>
                      <td>{FormatMoney(item.cartera_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_cartera, 0)}</td>
                      <td>{FormatMoney(item.objetivo, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_mes, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_activa, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_porvencer, 0)}</td>
                      <td>{FormatMoney(item.recuperacion_vencida, 0)}</td>
                      <td>{FormatMoney(item.total_recuperado, 0)}</td>
                      <td>{FormatMoney(item.recuperado, 0)}</td>
                      <td className="ta-right">{item.porc}</td>
                      <td className="td-porcentaje">
                        <div className="porcentaje">
                          <div
                            className={GetClassIndicador(item.indicador)}
                          ></div>
                          <div
                            className={GetClassIndicadordouble(item.indicador)}
                          ></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>
    </PlantillaScreen>
  );
};

export default RecuperacionCarteraMensualScreen;
